import { styled } from "@mui/material";

export const Overlay = styled("div")<{ isTutorialActive?: boolean }>`
	position: fixed;
	inset: 0;
	z-index: 9998;
	background-color: rgba(
		0,
		0,
		0,
		${(props) => (props.isTutorialActive ? 0 : 0.7)}
	);
	display: grid;
	overflow-y: auto;
	justify-content: center;
	align-items: center;

	&.scale {
		height: ${(props) => (props.isTutorialActive ? "fit-content" : "auto")};
		display: flex;
		grid-auto-columns: 1fr;
		overflow: hidden;
	}

	&.tutorial {
		background-color: rgba(0, 0, 0, 0.9);
	}
`;

export const Wrapper = styled("div")`
	position: relative;
`;
